export default __webpack_public_path__ + "fb1dc5bccf81f7b096e0936907719ea5.png";